<div class="container">
  <p class="copyright">&copy; 2025 MedCare Ltd. All rights reserved.</p>
  <div
    class="links-container"
    [class.hide]="hideLinks()"
  >
    <a
      class="copyright copyright--link"
      routerLink="/privacy-policy"
      >Privacy Policy</a
    >
    <a
      class="copyright copyright--link"
      routerLink="/terms-conditions"
      >Terms and Conditions</a
    >
  </div>
</div>
